const environmentType = process.env.ENVIRONMENT_TYPE; // 1测试环境 2正式环境
console.log(
  "NODE_ENV:",
  process.env.NODE_ENV,
  process.env.ENVIRONMENT_TYPE,
  environmentType
);
var base_develop_production_front_router,
  share_entry_url,
  base_url,
  signin_base_url,
  nextcloud_url,
  base_user_center,
  flowable_url;
if (environmentType == 1) {
  base_develop_production_front_router = "http://10.30.0.198:8032"; //测试服务器前端地址8032
  base_url = "http://10.30.0.198:8042"; // 测试服务器后端api请求地址
  // base_url = "http://172.31.2.107:5051"; // 测试服务器后端api请求地址
  signin_base_url = "http://10.30.0.198:8041/api/v1"; //测试登录地址
  nextcloud_url = "http://10.30.0.173:8066/"; //测试nextcloud地址
  base_user_center = "http://10.30.0.198:8031";
  flowable_url = "http://10.30.0.198:8092";
} else {
  base_develop_production_front_router = "https://mim.miningcloud.com.cn"; //正式服务器前端地址8032
  base_url = "https://mim.miningcloud.com.cn/api"; //正式服务器后端api请求地址
  base_user_center = "https://mimco.miningcloud.com.cn:8031"; //正式服务器用户中心地址
  // signin_base_url = "https://mimco.miningcloud.com.cn:8041/api/v1"; //线上登录地址
  signin_base_url = "https://mim.miningcloud.com.cn/user"; //线上登录地址
  nextcloud_url = "http://mimco.miningcloud.com.cn:8066/"; //测试nextcloud地址
  // flowable_url = "https://mimco.miningcloud.com.cn:8032";
  flowable_url = "https://mim.miningcloud.com.cn/flowables";
}
share_entry_url = `${base_develop_production_front_router}/index.html`;
export default {
  environmentType: environmentType,
  base_user_center: base_user_center,
  base_develop_production_front_router,
  share_entry_url,
  base_url,
  signin_base_url,
  nextcloud_url,
  flowable_url,
  // web_qrcode_url: 'http://10.30.0.198:8032',
  web_qrcode_url: `${share_entry_url}#/drawingModelShare?token=`,
  nextcloud_base_url: {
    url: `${nextcloud_url}`,
  },
  img_base_url: {
    url: `${base_url}`,
  },
  file_base_url: {
    url: `${base_url}`,
  },
  option_prod_dev_front_url: {
    url: base_develop_production_front_router,
  },
  option_route_to_user_center: {
    url: base_develop_production_front_router,
  },
  project_detail: {
    url: `${base_url}/project/project_detail`,
  },
  null_picture_url: {
    url: `${base_url}/project/null_picture_url`,
  },
  project_duplicate_detail: {
    url: `${base_url}/project/project_duplicate_detail`,
  },

  QueryDuplicateName: {
    url: `${base_url}/project/query_duplicate_detail`,
  },

  upload_img: {
    url: `${base_url}/project/upload_img`,
  },

  get_project_detail: {
    url: `${base_url}/project/get_project_detail`,
  },
  get_nickname: {
    url: `${base_url}/project/get_nickname`,
  },
  upload_error_then_delete: {
    url: `${base_url}/project/upload_error_then_delete`,
  },
  get_advisory_detail: {
    url: `${base_url}/project/get_advisory_detail`,
  },

  get_design_detail: {
    url: `${base_url}/project/get_design_detail`,
  },

  get_contractor_detail: {
    url: `${base_url}/project/get_contractor_detail`,
  },

  get_others_detail: {
    url: `${base_url}/project/get_others_detail`,
  },
  sendAsynCodeEmail: {
    url: `${base_url}/sendAsynCodeEmail`,
  },

  delete_project: {
    url: `${base_url}/project/delete_project`,
  },

  search_project: {
    url: `${base_url}/project/search_project`,
  },

  // upload_error_then_delete: {
  //     url: `${base_url}/project/upload_error_then_delete`
  // },

  survey_get_project: {
    url: `${base_url}/survey/survey_get_project`,
  },

  survey_get_project_node: {
    url: `${base_url}/survey/survey_get_project_node`,
  },

  survey_get_dyna_info: {
    url: `${base_url}/survey/survey_get_dyna_info`,
  },

  get_survey_table_data: {
    url: `${base_url}/survey/get_survey_table_data`,
  },

  add_user: {
    url: `${base_url}/setting/add_user`,
  },

  get_user_table: {
    url: `${base_url}/setting/get_user_table`,
  },

  get_project_table: {
    url: `${base_url}/setting/get_project_info`,
  },

  del_member_info: {
    url: `${base_url}/setting/del_member_info`,
  },
  get_validate_code: {
    url: `${signin_base_url}/user/getUserPhoneCode/`,
  },
  check_phone_unqiue: {
    url: `${signin_base_url}/user/checkTelephoneUnique/`,
  },
  check_validate_Code: {
    url: `${base_url}/user/checkValidateCode`,
  },
  //用户注册
  register_user: {
    url: `${signin_base_url}/user/registerUser/`,
  },
  login: {
    url: `${base_url}/user/login`,
  },
  check_login: {
    url: `${base_url}/user/checkLogin`,
  },
  loginout: {
    url: `${base_url}/user/logout`,
  },

  editMember: {
    url: `${base_url}/setting/editMember`,
  },

  batchEditMemberRole: {
    url: `${base_url}/setting/batchEditMemberRole`,
  },

  editProject: {
    url: `${base_url}/setting/editProject`,
  },

  edit_img: {
    url: `${base_url}/setting/edit_img`,
  },
  upload_model: {
    url: `${base_url}/mim/uploadModel`,
  },
  upload_cover: {
    url: `${base_url}/mim/uploadCover`,
  },
  add_mim_model: {
    url: `${base_url}/mim/addMimModel`,
  },
  get_mim_list: {
    url: `${base_url}/mim/getMimList`,
  },
  rename_mim: {
    url: `${base_url}/mim/renameMim`,
  },
  validate_mim: {
    url: `${base_url}/mim/validateDeleteModel`,
  },
  delete_mim: {
    url: `${base_url}/mim/deleteMim`,
  },
  check_mim_name: {
    url: `${base_url}/mim/checkMimName`,
  },
  get_format: {
    url: `${base_url}/mim/getFormat`,
  },
  search_mim_list: {
    url: `${base_url}/mim/searchMimList`,
  },
  get_history_version: {
    url: `${base_url}/mim/getHistoryVersion`,
  },
  delete_history_version: {
    url: `${base_url}/mim/deleteHistoryVersion`,
  },
  upload_model_file: {
    url: `${base_url}/mim/uploadModelFile`,
  },
  upload_model_version: {
    url: `${base_url}/mim/uploadModelVersion`,
  },
  get_increment_version: {
    url: `${base_url}/mim/getIncrementVersion`,
  },

  get_para_node: {
    url: `${base_url}/fileControl/get_node`,
  },
  get_child_node: {
    url: `${base_url}/fileControl/get_child_node`,
  },
  upload_folder: {
    url: `${base_url}/fileControl/upload_folder`,
  },
  get_file_info: {
    url: `${base_url}/fileControl/get_file`,
  },
  share_preview: {
    url: `${base_url}/fileControl/share_preview`,
  },

  upload_file: {
    url: `${base_url}/fileControl/upload_file`,
  },

  get_child_file: {
    url: `${base_url}/fileControl/get_child_file_new`,
  },

  delete_file: {
    url: `${base_url}/fileControl/delete_file`,
  },

  download_file: {
    url: `${base_url}/fileControl/download_file`,
  },

  preview_file: {
    url: `${base_url}/fileControl/preview`,
  },

  move_file: {
    url: `${base_url}/fileControl/move_file`,
  },

  copy_file: {
    url: `${base_url}/fileControl/copy_file`,
  },

  get_dir_node: {
    url: `${base_url}/fileControl/get_dir_node`,
  },

  create_tag: {
    url: `${base_url}/fileControl/create_tag`,
  },

  get_tag: {
    url: `${base_url}/fileControl/get_tag`,
  },
  get_have_set_tag: {
    url: `${base_url}/fileControl/get_have_set_tag`,
  },
  set_tag: {
    url: `${base_url}/fileControl/set_tag`,
  },
  tag_require_url: {
    url: `${base_url}/fileControl/tag_require`,
  },
  check_drawing_name: {
    url: `${base_url}/drawing/checkDrawingName`,
  },
  add_subitem: {
    url: `${base_url}/drawing/addSubitem`,
  },
  getBatchModelAuth: {
    url: `${base_url}/getBatchModelAuth`,
  },
  deleteBatchModelAuth: {
    url: `${base_url}/deleteBatchModelAuth`,
  },
  check_has_subitem: {
    url: `${base_url}/drawing/checkHasSubitem`,
  },
  get_click_subitem: {
    url: `${base_url}/drawing/getClickSubitem`,
  },
  upload_drawing: {
    url: `${base_url}/drawing/uploadDrawing`,
  },
  add_drawing: {
    url: `${base_url}/drawing/addDrawing`,
  },
  get_annotation_user: {
    url: `${base_url}/getAnnotationUser`,
  },
  get_upload_status: {
    url: `${base_url}/getBimfaceTranslateStatus`,
  },
  add_annotation: {
    url: `${base_url}/annotation/add`,
  },
  delete_annotation: {
    url: `${base_url}/annotation/delete`,
  },
  get_annotation: {
    url: `${base_url}/annotation/getAnnotationList`,
  },
  add_comment: {
    url: `${base_url}/comment/add`,
  },
  get_comments_details: {
    url: `${base_url}/comment/getCommentList`,
  },
  delete_comment: {
    url: `${base_url}/comment/delete`,
  },
  get_drawing_list: {
    url: `${base_url}/drawing/getDrawingList`,
  },
  search_drawing_list: {
    url: `${base_url}/drawing/searchDrawingList`,
  },
  validate_drawing: {
    url: `${base_url}/drawing/validateDeleteDrawing`,
  },
  delete_drawing: {
    url: `${base_url}/drawing/deleteDrawing`,
  },
  rename_drawing: {
    url: `${base_url}/drawing/renameDrawing`,
  },
  get_drawing_history_version: {
    url: `${base_url}/drawing/getDrawingHistoryVersion`,
  },
  delete_drawing_history_version: {
    url: `${base_url}/drawing/deleteDrawingHistoryVersion`,
  },
  get_drawing_increment_version: {
    url: `${base_url}/drawing/getDrawingIncrementVersion`,
  },
  upload_drawing_file: {
    url: `${base_url}/drawing/uploadDrawingFile`,
  },
  upload_drawing_version: {
    url: `${base_url}/drawing/uploadDrawingVersion`,
  },
  delete_subitem: {
    url: `${base_url}/drawing/deleteSubitem`,
  },
  rename_subitem: {
    url: `${base_url}/drawing/renameSubitem`,
  },
  //导出批注评论至word
  annotation_export: {
    url: `${base_url}/annotation_export`,
  },
  delete_annotation_export: {
    url: `${base_url}/delete_annotation_export`,
  },
  create_new_file: {
    url: `${base_url}/fileControl/create_new_file`,
  },
  get_bimface_view_token: {
    url: `${base_url}/getBimfaceViewToke`,
  },
  get_batch_bimface_view_token: {
    url: `${base_url}/getBatchBimfaceViewToke`,
  },
  download_through_share: {
    url: `${base_url}/fileControl/download_through_share`,
  },
  comprehensive_operation: {
    url: `${base_url}/fileControl/comprehensive_operation`,
  },
  get_operation_file: {
    url: `${base_url}/fileControl/get_operation_file`,
  },

  get_share_file: {
    url: `${base_url}/fileControl/get_share_file`,
  },

  search_file: {
    url: `${base_url}/fileControl/search_new`,
  },

  reload_this_page: {
    url: `${base_url}/fileControl/get_peer_dir`,
  },

  model_preview_test: {
    url: `${base_url}/fileControl/connect_preview`,
  },

  preview_test: {
    url: `${base_url}/fileControl/preview`,
  },

  rename_file: {
    url: `${base_url}/fileControl/rename`,
  },

  order_by_filesize: {
    url: `${base_url}/fileControl/orderfile`,
  },

  get_to_data: {
    url: `${base_url}/fileControl/get_to_data`,
  },

  get_auth_user: {
    url: `${base_url}/fileControl/get_auth_user`,
  },

  set_auth_url: {
    url: `${base_url}/fileControl/set_auth_url`,
  },
  query_same_level: {
    url: `${base_url}/fileControl/query_same_level`,
  },

  delete_auth_url: {
    url: `${base_url}/fileControl/delete_auth`,
  },
  add_favorite: {
    url: `${base_url}/fileControl/add_favorite`,
  },
  query_favorite: {
    url: `${base_url}/fileControl/query_favorite`,
  },
  cancel_favorite: {
    url: `${base_url}/fileControl/cancel_favorite`,
  },
  add_recycle: {
    url: `${base_url}/fileControl/add_recycle`,
  },
  query_recyle: {
    url: `${base_url}/fileControl/query_recyle`,
  },
  recover_recyle: {
    url: `${base_url}/fileControl/recover_recyle`,
  },
  recycle_delete: {
    url: `${base_url}/fileControl/recycle_delete`,
  },
  suggest_query: {
    url: `${base_url}/fileControl/suggest_query`,
  },
  get_file_from_file_control: {
    url: `${base_url}/fileControl/get_file_from_fileControl`,
  },
  preview_drawing_model_in_file: {
    url: `${base_url}/fileControl/preview_drawing_model`,
  },
  read_drawing_from_file: {
    url: `${base_url}/fileControl/read_drawing_from_file`,
  },
  trans_file: {
    url: `${base_url}/file/trans`,
  },
  add_drawing_from_file: {
    url: `${base_url}/fileControl/add_drawing_from_file`,
  },
  add_modeling_from_file: {
    url: `${base_url}/fileControl/add_modeling_from_file`,
  },
  getProjectUser: {
    url: `${base_url}/getProjectUser`,
  },
  setModelAuth: {
    url: `${base_url}/setModelAuth`,
  },
  getModelAuth: {
    url: `${base_url}/getModelAuth`,
  },
  deleteModelAuth: {
    url: `${base_url}/deleteModelAuth`,
  },
  batchDeleteDrawing: {
    url: `${base_url}/drawing/batchDeleteDrawing`,
  },
  batchAuthDrawing: {
    url: `${base_url}/setBatchModelAuth`,
  },
  query_auth_create: {
    url: `${base_url}/fileControl/query_auth_create`,
  },
  is_auth_share: {
    url: `${base_url}/fileControl/is_auth_share`,
  },
  cancel_share: {
    url: `${base_url}/fileControl/cancel_share`,
  },
  share_file: {
    url: `${base_url}/fileControl/share_file`,
  },

  share_get_child_file: {
    url: `${base_url}/fileControl/share_get_child_file`,
  },

  get_my_role: {
    url: `${base_url}/setting/get_my_role`,
  },
  query_file_bound: {
    url: `${base_url}/mim/query_file_bound`,
  },
  dbclickAuthFile: {
    url: `${base_url}/dbclickAuthFile`,
  },

  connect_file: {
    url: `${base_url}/connect_file`,
  },
  delete_file_bound: {
    url: `${base_url}/mim/delete_file_bound`,
  },
  checktotalsize: {
    url: `${base_url}/checktotalsize`,
  },
  checkDrawingModelRepeat: {
    url: `${base_url}/checkDrawingModelRepeat`,
  },
  check_zixiang_name: {
    url: `${base_url}/drawing/checkZiXiangName`,
  },
  folder_chunk_upload: {
    url: `${base_url}/upload/chunkUpload`,
  },
  folder_chunk_upload2: {
    url: `${base_url}/upload/chunkUpload2`,
  },
  folder_merge_chunk_file: {
    url: `${base_url}/upload/mergeChunkFile`,
  },
  folder_move_merge_file: {
    url: `${base_url}/upload/dealFile`,
  },
  task_query: {
    url: `${base_url}/tasks/query`,
  },
  remove_task: {
    url: `${base_url}/tasks/remove`,
  },
  check_is_duplicate: {
    url: `${base_url}/fileControl/check_is_duplicate`,
  },

  delete_actual_directory: {
    url: `${base_url}/fileControl/delete_actual_directory`,
  },
  checkFolder: {
    url: `${base_url}/upload/checkFolder`,
  },
  //新版本获取列表
  file_list: {
    url: `${base_url}/file/list`,
  },
  file_list2: {
    url: `${base_url}/file/list/all`,
  },
  //新版本获取收藏夹列表
  file_favorite: {
    url: `${base_url}/file/favorite`,
  },
  //新版本获取分享列表
  file_share: {
    url: `${base_url}/file/share`,
  },
  //新版本获取回收站列表
  file_recycle: {
    url: `${base_url}/file/recycle`,
  },
  //新版本获取tag列表
  file_tag: {
    url: `${base_url}/file/tag`,
  },
  //新版新建文件夹
  file_addFolder: {
    url: `${base_url}/file/addFolder`,
  },
  //新版下载文件
  file_download: {
    url: `${base_url}/file/download`,
  },
  //新版收藏文件
  file_favorite_add: {
    url: `${base_url}/file/favorite/add`,
  },
  //新版取消收藏
  file_favorite_remove: {
    url: `${base_url}/file/favorite/remove/`,
  },
  //新版文件复制移动
  file_copyMove: {
    url: `${base_url}/file/copyMove`,
  },
  //新版获取tag下拉列表
  file_tag_all: {
    url: `${base_url}/file/tag/all`,
  },
  //新版创建标签
  file_tag_add: {
    url: `${base_url}/file/tag/add`,
  },
  //新版文件链接标签
  file_tag_node_add: {
    url: `${base_url}/file/tag/node/add`,
  },
  //新版移除文件与标签
  file_tag_node_remove: {
    url: `${base_url}/file/tag/node/remove/`,
  },
  //新版删除文件到回收站
  file_delete: {
    url: `${base_url}/file/delete`,
  },
  //新版获取文件夹用户权限
  file_auth_node: {
    url: `${base_url}/file/auth/node/`,
  },
  //新版修改权限
  file_auth_edit: {
    url: `${base_url}/file/auth/edit`,
  },
  //新版移除授权
  file_auth_remove: {
    url: `${base_url}/file/auth/remove/`,
  },
  //新版文件夹添加权限
  file_auth_add: {
    url: `${base_url}/file/auth/add`,
  },
  //新版文件上传
  file_upload: {
    url: `${base_url}/file/upload_file`,
  },
  //新版永久删除
  file_recycle_delete: {
    url: `${base_url}/file/recycle/delete`,
  },
  //新版回收站文件还原
  file_delete_back: {
    url: `${base_url}/file/delete/back`,
  },
  //新版创建文件共享
  file_share_create: {
    url: `${base_url}/file/share/create`,
  },
  //新版取消文件共享
  file_share_remove: {
    url: `${base_url}/file/share/remove/`,
  },
  //分享域名
  share_domain_name: {
    url: base_develop_production_front_router,
  },
  //新版重命名
  file_rename: {
    url: `${base_url}/file/rename`,
  },
  //新版根据分享token获取分享文件列表
  file_share_preview: {
    url: `${base_url}/file/share/preview/`,
  },
  //新版分享页面获取分享的子目录列表
  file_share_preview_list: {
    url: `${base_url}/file/share/preview/list`,
  },
  //新版分享下载
  file_share_preview_download: {
    url: `${base_url}/file/share/preview/download`,
  },
  //mim格式模型结构数
  file_mim_tree: {
    url: `${base_url}/file/mim/tree/`,
  },
  file_mim_treeFormat: {
    url: `${base_url}/mim/mimFormat/tree/`,
  },
  file_mim_tree_deliverData: {
    url: `${base_url}/deliver/model/mim/tree`,
  },
  //矿体模型 上传dgn
  data_report_save_dgn: {
    url: `${base_url}/Mine_Statistic/save_dgn`,
  },
  //矿体模型 上传csv
  data_report_save_file: {
    url: `${base_url}/Mine_Statistic/save_csv`,
  },
  //矿体模型 显示100条数据
  data_report_read_csv: {
    url: `${base_url}/Mine_Statistic/read_csv`,
  },
  //矿体模型 统计
  data_report_statistic: {
    url: `${base_url}/Mine_Statistic/statistic`,
  },
  //矿体模型 热力图数据
  data_report_heat_map: {
    url: `${base_url}/Mine_Statistic/heat_map`,
  },
  //矿体模型 获取切面数据
  data_report_section: {
    url: `${base_url}/Mine_Statistic/section`,
  },
  //矿体模型 查找已存在的csv
  data_report_find_csv: {
    url: `${base_url}/Mine_Statistic/find_csv`,
  },
  //矿体模型 查找已存在的dgn
  data_report_find_dgn: {
    url: `${base_url}/Mine_Statistic/find_dgn`,
  },
  //用户登陆
  login_url: {
    url: `${signin_base_url}/user/login/`,
  },
  //用户登出
  logout_url: {
    url: `${signin_base_url}/user/logout/`,
  },
  //获取验证码
  verifycode_url: {
    url: `${signin_base_url}/verifycode/register_via_mobile/`,
  },
  //获取验证码，通过验证码进行登陆
  login_via_mobile_code: {
    url: `${signin_base_url}/verifycode/login_via_mobile_code/`,
  },
  //通过验证码登陆
  phoneLogin: {
    url: `${signin_base_url}/user/phoneLogin/`,
  },
  //获取图形验证码
  verifycode_token: {
    url: `${signin_base_url}/verifycode/token`,
  },
  //工单列表
  work_order_query_list: {
    url: `${base_url}/workOrder/query`,
  },
  //创建工单
  work_order_create: {
    url: `${base_url}/workOrder/create`,
  },
  //验证用户是否为管理员
  setting_check_auth_add_user: {
    url: `${base_url}/setting/check_auth_add_user`,
  },
  //重置密码获取验证码
  verifycode_fetchpassword_via_mobile_url: {
    url: `${signin_base_url}/verifycode/fetchpassword_via_mobile/`,
  },
  //重置密码
  change_password_url: {
    url: `${signin_base_url}/user/change_password/`,
  },
  //个人用户注册
  user_register_url: {
    url: `${signin_base_url}/user/register/`,
  },
  //工单详情
  workOrder: {
    url: `${base_url}/workOrder/`,
  },
  //发起消息
  notice_create: {
    url: `${base_url}/notice/create`,
  },
  //获取消息列表
  notice_query: {
    url: `${base_url}/notice/query`,
  },
  // 添加自定义角色名称
  add_role: {
    url: `${base_url}/setting/add_role`,
  },
  // 展示所有角色信息
  role_list: {
    url: `${base_url}/setting/list_role`,
  },
  // 删除角色
  delRole: {
    url: `${base_url}/setting/delete_role`,
  },
  // 模型管理获取子项
  getSubItem: {
    url: `${base_url}/mim/checkHasModelSubitem`,
  },
  // 检查模型管理子项名称是否重复
  checkSubName: {
    url: `${base_url}/mim/checkModelSubName`,
  },
  // 添加模型子项
  addModelSub: {
    url: `${base_url}/mim/addModelSubitem`,
  },
  // 删除模型子项
  deleteModelSub: {
    url: `${base_url}/mim/deleteModelSubitem`,
  },
  // 编辑子项
  editSub: {
    url: `${base_url}/mim/renameModelSubitem`,
  },
  // 重命名子项
  renameSub: {
    url: `${base_url}/mim/renameModelSubitem`,
  },
  // 删除模型验证
  delete_model_auth: {
    url: `${base_url}/mim/validateDeleteModel`,
  },
  // 批量删除模型验证
  delete_model_batch_auth: {
    url: `${base_url}/mim/validateBatchDeleteModel`,
  },
  // 批量删除模型
  batch_delete_model: {
    url: `${base_url}/mim/batchDeleteModel`,
  },
  //批量删除图纸验证
  delete_drawing_batch_auth: {
    url: `${base_url}/drawing/validateBatchDeleteDrawing`,
  },
  //删除单个图纸验证
  delete_drawing_validateDeleteDrawing: {
    url: `${base_url}/drawing/validateDeleteDrawing`,
  },
  //验证图纸批量授权
  delete_drawing_validateBatchAuth: {
    url: `${base_url}/validateBatchAuth`,
  },
  //批量授权验证
  batch_auth: {
    url: `${base_url}/validateBatchAuth`,
  },
  //消息回复
  notice_reply: {
    url: `${base_url}/notice/reply`,
  },
  //项目成员统计图表
  project_role_count: {
    url: `${base_url}/setting/project_role_count`,
  },
  //标记消息已读
  notice_readMark: {
    url: `${base_url}/notice/readMark`,
  },
  // 模型管理-修改子项
  change_subItem: {
    url: `${base_url}/mim/updateModelSubitem`,
  },
  // 申请mim应用
  apply_mim_app: {
    url: `${base_url}/setting/add_mim_application`,
  },
  //日志列表查询
  user_journal: {
    url: `${base_url}/log/query`,
  },
  //删除用户日志
  delete_journal: {
    url: `${base_url}/log/delete`,
  },
  //获取模型子项下拉
  getClickModelSubitem: {
    url: `${base_url}/mim/getClickModelSubitem`,
  },
  //获取项目日志列表
  project_journal: {
    url: `${base_url}/log/project/query`,
  },
  //删除项目日志
  project_delete_journal: {
    url: `${base_url}/log/project/delete`,
  },
  // 加载mim所有应用
  load_mim_app: {
    url: `${base_url}/setting/mim_application_list`,
  },
  // 统计项目占用空间大小
  get_total_file_size: {
    url: `${base_url}/setting/get_total_file_size`,
  },
  // 删除mim应用
  delete_mim_application: {
    url: `${base_url}/setting/delete_mim_application`,
  },
  // 申请加入项目
  apply_duplicate_detail: {
    url: `${base_url}/project/apply_duplicate_detail`,
  },
  //上传PDF图纸
  drawing_addPdfFile: {
    url: `${base_url}/drawing/addPdfFile`,
  },
  //查询pdf文件信息
  drawing_getPdfFile: {
    url: `${base_url}/drawing/getPdfFile`,
  },
  //生成图纸模型链接
  get_model_drawing_share: {
    url: `${base_url}/getModelDrawingShare`,
  },
  //验证图纸模型链接
  get_validate_model_token: {
    url: `${base_url}/getValidateModelToken`,
  },
  // 退出项目
  exist_project: {
    url: `${base_url}/setting/exist_project`,
  },
  //生成图纸模型链接
  get_model_drawing_share_link: {
    url: `${base_url}/getModelDrawingShareLink`,
  },
  //生成图纸模型链接
  delete_model_drawing_share_link: {
    url: `${base_url}/deleteModelDrawingShareLink`,
  },

  // 对项目进行收藏
  add_favs: {
    url: `${base_url}/project/add_favs`,
  },
  // 取消项目收藏
  cancel_favs: {
    url: `${base_url}/project/cancel_favs`,
  },
  // 获取收藏项目pane
  get_favorite_detail: {
    url: `${base_url}/project/get_favs`,
  },

  // 获取设置了mim应用项目成员
  relate_member: {
    url: `${base_url}/setting/relate_member`,
  },

  // 获取项目应用、成员options
  get_options: {
    url: `${base_url}/setting/get_options`,
  },

  // 保存配置项目应用、成员
  save_member: {
    url: `${base_url}/setting/save_member`,
  },
  // 删除成员-应用对应关系
  delete_member: {
    url: `${base_url}/setting/delete_member`,
  },
  // 查询人员可以看到的mim应用
  query_member_application: {
    url: `${base_url}/setting/mim_application_pass_list`,
  },
  //我的应用
  my_application: {
    url: `${base_url}/applyProject/query`,
  },
  //获取系统未读消息数
  notice_unread_num: {
    url: `${base_url}/notice/unread/num/`,
  },
  //模型集成
  integrateModel: {
    url: `${base_url}/integrate/integrateModel`,
  },
  //已集成模型列表
  integrate_query_model: {
    url: `${base_url}/integrate/query_model`,
  },
  //集成模型重命名
  integrate_renames: {
    url: `${base_url}/integrate/renames`,
  },
  //删除集成模型
  remove_integrate_model: {
    url: `${base_url}/integrate/delete`,
  },
  //集成模型状态查询
  integrate_query_status: {
    url: `${base_url}/integrate/query_status`,
  },
  //集成模型获取viewtoken
  integrate_get_integrate_viewToken: {
    url: `${base_url}/integrate/get_integrate_viewToken`,
  },
  //批量转换模型
  fileControl_batch_trans: {
    // url: `${base_url}/fileControl/batch_trans`,
    url: `${base_url}/file/trans`,
  },
  //集成模型 获取项目角色
  integrate_getProjectUser: {
    url: `${base_url}/integrate/getProjectUser`,
  },
  //集成模型批量授权
  integrate_auth_integrate: {
    url: `${base_url}/integrate/auth_integrate`,
  },
  //集成模型已授权预览
  integrate_getUserAuth: {
    url: `${base_url}/integrate/getUserAuth`,
  },
  //删除集成模型权限
  integrate_delete_auth: {
    url: `${base_url}/integrate/delete_auth`,
  },
  //修改项目默认模型
  setting_edit_model: {
    url: `${base_url}/setting/edit_model`,
  },
  //消息  系统消息标记全部已读
  notice_readMarkAll: {
    url: `${base_url}/notice/readMarkAll`,
  },
  // 流程 获取指定流程办理组列表
  process_roleList: {
    url: `${flowable_url}/flowable/definition/roleList`,
  },
  // 流程 获取指定流程办理人员列表
  process_userList: {
    url: `${flowable_url}/flowable/definition/userList`,
  },
  // 流程 保存流程xml
  process_save_xml: {
    url: `${flowable_url}/flowable/definition/save`,
  },
  process_list: {
    url: `${flowable_url}/flowable/definition/list`,
  },
  process_read_xml: {
    url: (deployId) =>
      `${flowable_url}/flowable/definition/readXml/${deployId}`,
  },
  process_batch_delete: {
    url: `${flowable_url}/flowable/definition/del`,
  },
  process_update_state: {
    url: `${flowable_url}/flowable/definition/updateState`,
  },
  process_my_process: {
    url: `${flowable_url}/flowable/task/myProcess`,
  },
  process_stop_process: {
    url: `${flowable_url}/flowable/instance/stopProcessInstance`,
  },
  process_dict: {
    url: (dictType) => `${flowable_url}/system/dict/data/type/${dictType}`,
  },
  process_instance_record: {
    url: `${flowable_url}/flowable/task/flowRecord`,
  },
  process_flow_viewer: {
    url: (procInsId) => `${flowable_url}/flowable/task/flowViewer/${procInsId}`,
  },
  process_start_instance: {
    url: (procDefId) =>
      `${flowable_url}/flowable/instance/startBy/${procDefId}`,
  },
  process_get_variables: {
    url: (taskId) => `${flowable_url}/flowable/task/processVariables/${taskId}`,
  },
  process_revoke_process: {
    url: `${flowable_url}/flowable/task/revokeProcess`,
  },
  process_batch_delete_instance: {
    url: `${flowable_url}/flowable/instance/delete`,
  },
  task_complete: {
    url: `${flowable_url}/flowable/task/complete`,
  },
  task_todo_list: {
    url: `${flowable_url}/flowable/task/todoList`,
  },
  task_finished_list: {
    url: `${flowable_url}/flowable/task/finishedList`,
  },
  task_next_flow_node: {
    url: `${flowable_url}/flowable/task/nextFlowNode`,
  },
  task_reject: {
    url: `${flowable_url}/flowable/task/reject`,
  },
  task_return_list: {
    url: `${flowable_url}/flowable/task/returnList`,
  },
  task_batch_delete: {
    url: `${flowable_url}/flowable/task/delete`,
  },
  task_return_task: {
    url: `${flowable_url}/flowable/task/return`,
  },
  task_add_deployment: {
    url: `${flowable_url}/system/deployment`,
  },
  task_get_deployment: {
    url: (id) => `${flowable_url}/system/deployment/${id}`,
  },
  task_update_deployment: {
    url: `${flowable_url}/system/deployment`,
  },
  task_del_deployment: {
    url: (id) => `${flowable_url}/system/deployment/${id}`,
  },
  export_deployment: {
    url: `${flowable_url}/system/deployment/export`,
  },
  task_delegate: {
    url: `${flowable_url}/flowable/task/delegate`,
  },
  task_deploy_start: {
    url: (deployId) => `${flowable_url}/flowable/process/startFlow/${deployId}`,
  },
  form_list: {
    url: `${flowable_url}/flowable/form/list`,
  },
  form_add_deploy_form: {
    url: `${flowable_url}/flowable/form/addDeployForm`,
  },
  form_get_form: {
    url: (formId) => `${flowable_url}/flowable/form/${formId}`,
  },
  form_add_form: {
    url: `${flowable_url}/flowable/form`,
  },
  form_batch_delete: {
    url: `${flowable_url}/flowable/form/del`,
  },
  form_upload: {
    url: `${flowable_url}/common/upload`,
  },
  //模型图纸预览加如日志
  model_browseModelDrawing: {
    url: `${base_url}/model/browseModelDrawing`,
  },
  //微信登录 获取微信登录二维码链接
  wechat_qrcode: {
    url: `${signin_base_url}/wechat/qrcode`,
    // url:`http://172.31.2.99:5000/api/v1/wechat/qrcode`,
  },
  //微信登录
  wechat_checkLogin: {
    url: `${signin_base_url}/wechat/checkLogin`,
    // url:`http://172.31.2.99:5000/api/v1/wechat/checkLogin`,
  },
  //微信登录 检查是否绑定成功接口
  wechat_checkBind: {
    url: `${signin_base_url}/wechat/checkBind`,
    // url:`http://172.31.2.99:5000/api/v1/wechat/checkBind`,
  },
  //微信登录 解除微信绑定
  wechat_unBind: {
    url: `${signin_base_url}/wechat/unBind`,
    // url:`http://172.31.2.99:5000/api/v1/wechat/unBind`,
  },
  //图纸 模型管理获取文档中文件列表
  file_list_filter: {
    url: `${base_url}/file/list/filter`,
  },

  //管理员登陆后台管理页面
  // 获取次数统计
  get_count: {
    url: `${base_url}/miningcould/index/count`,
  },
  // 获取项目列表
  get_project: {
    url: `${base_url}/miningcould/project`,
  },
  // 项目配置
  project_config: {
    url: `${base_url}/miningcould/project/update`,
  },
  // 获取项目详情
  get_all_project_detail: {
    url: `${base_url}/miningcould/project/detail/`,
  },
  //获取管理员列表
  change_admin: {
    url: `${base_url}/admin/project/transfer`,
  },
  //获取应用列表
  application_list: {
    url: `${base_url}/setting/mim_application_list`,
  },
  //应用上传图片及地址
  upload_pic: {
    url: `${base_url}/setting/update_mim_application`,
  },
  //审核应用
  approve_application: {
    url: `${base_url}/setting/approve_mim_application`,
  },
  // 获取柱状图数据
  get_histogram: {
    url: `${base_url}/miningcould/index/barPic`,
  },
  //通过项目ID查询该项目绑定的所有示例应用
  appManager_demo_project: {
    url: `${base_url}/appManager/demo/project`,
  },
  //退出项目
  setting_exist_project: {
    url: `${base_url}/setting/exist_project`,
  },
  //首页项目列表获取
  index_project_list: {
    url: `${base_url}/index/project/list`,
  },
  //微信绑定获取验证码
  wechat_bind_code: {
    url: `${signin_base_url}/wechat/bind/code`,
  },
  //通过手机号验证码绑定
  wechat_bind_phone: {
    url: `${signin_base_url}/wechat/bin/phone`,
  },
  //获取本机IP
  public_host: {
    url: `${base_url}/public/host`,
  },
  //文档管理-判断是否有权预览
  file_preview_office_dcs_auth: {
    url: `${base_url}/file/preview/office/dcs/auth`,
  },
  //其他系统登录
  other_login: {
    url: `${signin_base_url}/user/single_login`,
  },
};



// WEBPACK FOOTER //
// ./src/url/api.js